var map = {
	"./Anyswap.png": 742,
	"./Anyswap.svg": 743,
	"./Artwork.svg": 744,
	"./Artwork_gmx.svg": 745,
	"./Banxa.png": 746,
	"./DROP_DOWN.svg": 377,
	"./Hop.png": 747,
	"./Hop.svg": 748,
	"./Hop_dark.png": 749,
	"./Hop_dark.svg": 750,
	"./Synapse.png": 751,
	"./Synapse.svg": 752,
	"./binance.png": 753,
	"./bscscan.png": 754,
	"./btn_big_arbitrum.png": 755,
	"./btn_big_avalanche.png": 756,
	"./btn_big_bsc.png": 757,
	"./btn_big_purchasegmx.png": 758,
	"./btn_big_purchasegmx.svg": 759,
	"./buy_gmx.svg": 760,
	"./buy_gmx_bond.svg": 761,
	"./buy_transfer_eth.svg": 762,
	"./coinbaseWallet.png": 763,
	"./coingecko.png": 764,
	"./cross.svg": 765,
	"./ddl/chevron-down.svg": 766,
	"./ddl/chevron-down_sm.svg": 767,
	"./ddl/ic_btc_40.png": 768,
	"./ddl/ic_btc_40.svg": 439,
	"./ddl/ic_dai_40.png": 769,
	"./ddl/ic_dai_40.svg": 440,
	"./ddl/ic_eth_40.png": 770,
	"./ddl/ic_eth_40.svg": 254,
	"./ddl/ic_frax_40.png": 771,
	"./ddl/ic_frax_40.svg": 441,
	"./ddl/ic_link_40.png": 772,
	"./ddl/ic_link_40.svg": 442,
	"./ddl/ic_uni_40.png": 773,
	"./ddl/ic_uni_40.svg": 443,
	"./ddl/ic_usdc_40.png": 774,
	"./ddl/ic_usdc_40.svg": 444,
	"./ddl/ic_usdt_40.png": 775,
	"./ddl/ic_usdt_40.svg": 445,
	"./ddl/ic_weth_40.png": 776,
	"./ddl/ic_weth_40.svg": 446,
	"./ddl/icon_arrow.svg": 777,
	"./ddl/icon_check.svg": 778,
	"./ddl/icon_close.svg": 779,
	"./ddl/icon_close_sm.svg": 780,
	"./ddl/icon_close_toast.svg": 781,
	"./ddl/icon_dollar.svg": 378,
	"./ddl/icon_dollar_active.svg": 379,
	"./ddl/icon_market.svg": 380,
	"./ddl/icon_market_active.svg": 381,
	"./ddl/icon_trigger.svg": 382,
	"./ddl/icon_trigger_active.svg": 383,
	"./ddl/icon_withdraw.svg": 384,
	"./ddl/icon_withdraw_active.svg": 385,
	"./ddl/lock.svg": 782,
	"./ddl/long.svg": 386,
	"./ddl/long_active.svg": 387,
	"./ddl/short.svg": 388,
	"./ddl/short_active.svg": 389,
	"./flag_en.svg": 783,
	"./flag_es.svg": 784,
	"./flag_fr.svg": 785,
	"./flag_ja.svg": 786,
	"./flag_ko.svg": 787,
	"./flag_ru.svg": 788,
	"./flag_zh.svg": 789,
	"./glp_icon.svg": 790,
	"./gmx-logo-final-white-small.png": 791,
	"./gmx-logo-final-white.png": 792,
	"./gmx-logo-final.png": 793,
	"./gmx-logo-glow.png": 794,
	"./gmx-logo-with-name.svg": 390,
	"./gmx_logo.svg": 795,
	"./graphite-01.png": 796,
	"./ic-communityproject.svg": 797,
	"./ic_arbitrum_16.svg": 798,
	"./ic_arbitrum_24.svg": 447,
	"./ic_arbitrum_96.svg": 799,
	"./ic_arbitrum_hover_16.svg": 800,
	"./ic_arrowleft16.svg": 801,
	"./ic_arrowright16.svg": 802,
	"./ic_avalanche_16.svg": 803,
	"./ic_avalanche_24.svg": 448,
	"./ic_avalanche_96.svg": 804,
	"./ic_avax_24.svg": 449,
	"./ic_avax_30.svg": 805,
	"./ic_avax_40.svg": 806,
	"./ic_banxa.svg": 807,
	"./ic_binance_logo.svg": 808,
	"./ic_bsc.svg": 809,
	"./ic_bsc_96.svg": 810,
	"./ic_btc.b_24.svg": 450,
	"./ic_btc.b_40.svg": 811,
	"./ic_btc_24.svg": 451,
	"./ic_btc_40.svg": 812,
	"./ic_busd_24.svg": 452,
	"./ic_buy_glp.svg": 813,
	"./ic_cash.png": 814,
	"./ic_cash.svg": 815,
	"./ic_checked.svg": 816,
	"./ic_coingecko_16.svg": 817,
	"./ic_coingecko_hover_16.svg": 818,
	"./ic_convert_down.svg": 819,
	"./ic_copy_16.svg": 820,
	"./ic_cost.svg": 821,
	"./ic_dai_24.svg": 453,
	"./ic_dai_40.svg": 822,
	"./ic_discord.svg": 823,
	"./ic_eth_24.svg": 454,
	"./ic_eth_40.svg": 824,
	"./ic_frax_24.svg": 455,
	"./ic_frax_40.svg": 825,
	"./ic_github.svg": 826,
	"./ic_glp_24.svg": 456,
	"./ic_glp_40.svg": 827,
	"./ic_glp_custom.svg": 828,
	"./ic_gmx.svg": 829,
	"./ic_gmx_24.svg": 457,
	"./ic_gmx_30.svg": 830,
	"./ic_gmx_40.svg": 831,
	"./ic_gmx_64.svg": 832,
	"./ic_gmx_arbitrum.svg": 833,
	"./ic_gmx_avax.svg": 834,
	"./ic_gmx_big.svg": 835,
	"./ic_gmx_custom.svg": 836,
	"./ic_gmx_footer.svg": 837,
	"./ic_hop.svg": 838,
	"./ic_info.svg": 839,
	"./ic_language24.svg": 840,
	"./ic_link_24.svg": 458,
	"./ic_link_40.svg": 841,
	"./ic_liquidity.svg": 842,
	"./ic_medium.svg": 843,
	"./ic_menu_dots.svg": 844,
	"./ic_metamask_16.svg": 845,
	"./ic_metamask_hover_16.svg": 846,
	"./ic_mim_24.svg": 459,
	"./ic_mim_40.svg": 847,
	"./ic_multiswap.svg": 848,
	"./ic_new_link_16.svg": 849,
	"./ic_olympus.svg": 850,
	"./ic_olympus_arbitrum.svg": 851,
	"./ic_selector_dropdowns.svg": 852,
	"./ic_settings_16.svg": 853,
	"./ic_settings_24.svg": 460,
	"./ic_sign in_16.svg": 854,
	"./ic_sign_out_16.svg": 855,
	"./ic_simpleswaps.svg": 856,
	"./ic_stats.svg": 857,
	"./ic_stats_big.svg": 858,
	"./ic_synapse.svg": 859,
	"./ic_telegram.svg": 860,
	"./ic_tether_24.svg": 461,
	"./ic_tokens.svg": 861,
	"./ic_totaluser.svg": 862,
	"./ic_trading.svg": 863,
	"./ic_transfer_avax.svg": 864,
	"./ic_twitter.svg": 865,
	"./ic_uni_24.svg": 462,
	"./ic_uni_40.svg": 866,
	"./ic_usdc.e_24.svg": 463,
	"./ic_usdc.e_40.svg": 867,
	"./ic_usdc_24.svg": 464,
	"./ic_usdc_40.svg": 868,
	"./ic_usdt_24.svg": 465,
	"./ic_usdt_40.svg": 869,
	"./ic_wallet_24.svg": 466,
	"./ic_wavax_24.svg": 467,
	"./ic_wavax_40.svg": 870,
	"./ic_weth_24.svg": 468,
	"./ic_weth_40.svg": 871,
	"./lg_arbitrum.svg": 872,
	"./logo_GMX.svg": 873,
	"./logo_GMX_small.svg": 874,
	"./long.svg": 875,
	"./metamask-text.svg": 876,
	"./metamask.png": 877,
	"./page-not-found.svg": 878,
	"./position-share-bg.png": 391,
	"./short.svg": 879,
	"./swap.svg": 392,
	"./trading.jpg": 880,
	"./wallet-connect-text.svg": 881,
	"./walletconnect-circle-blue.svg": 882,
	"./wave-01.png": 883,
	"./wave-02.png": 884
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 741;